import React, { useState, useEffect } from 'react';
import { Form, Button } from 'react-bootstrap';

import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { Typeahead } from 'react-bootstrap-typeahead';
import InputMask from "react-input-mask";
import CurrencyInput from 'react-currency-input-field';
import Calendar from 'react-calendar';
import ReCAPTCHA from "react-google-recaptcha";

import { format } from 'date-fns';

import ImageUploading from 'react-images-uploading';
import { ImageAdd } from '@styled-icons/boxicons-regular/ImageAdd';
import { DeleteForever } from '@styled-icons/material/DeleteForever';
import { CommentEdit } from '@styled-icons/boxicons-regular/CommentEdit';

import MyUploadAdapter from "./MyUploadAdapter";

import 'react-calendar/dist/Calendar.css';

const logCampos = (meta) => {    
    if(meta.touched && meta.error && meta.error !== 'Obrigatório'){
        return (
            <>        
            <Form.Control.Feedback             
                placement='right'
                tabIndex='-1' className='d-block' 
                type={meta.error?'invalid':'valid'}
                >
                {meta.error}
            </Form.Control.Feedback>
            </>
        )
    }
}

export const campocaptch = ({label, meta, form, lingua}) => {
    
    const handleChange = (response) => {        
        form.change('validado', response);
    }
        
    return (
        <>
            <Form.Label className="font-weight-bold">
                {label}
            </Form.Label>
            {logCampos(meta)}
            <ReCAPTCHA                
                sitekey="6LcNUwkaAAAAABYDNhzPgknmLllP83TiMifxd6J6"
                onChange={handleChange}
                hl={lingua}
            />            
        </>
    );
}

export const campotexto = ({input, label, placeholder, meta, readOnly, mask, styles, maskPlaceholder}) => {    
    return (
        <>
            <Form.Label className="font-weight-bold" style={styles?styles[input.name]:{}}>
                {label}
            </Form.Label>
            <Form.Control 
            isValid={meta.touched && !meta.error}
            isInvalid={meta.touched && meta.error}
            as={InputMask} 
            mask={mask} 
            maskPlaceholder={maskPlaceholder} 
            {...input} 
            placeholder={placeholder} 
            readOnly={readOnly} />            
            {logCampos(meta)}
        </>
    );
}

export const campotextarea = ({input, label, placeholder, meta, readOnly, styles, rows}) => {
    return (
        <>
            <Form.Label className="font-weight-bold" style={styles?styles[input.name]:{}}>
                {label}
            </Form.Label>
            <Form.Control 
            isValid={meta.touched && !meta.error}
            isInvalid={meta.touched && meta.error}
            as="textarea"
            rows={rows}
            {...input} 
            placeholder={placeholder} 
            readOnly={readOnly} />            
            {logCampos(meta)}
        </>
    );
}

export const campomoney = ({input, label, placeholder, meta, readOnly, form}) => {    

    const handleChangeMony = (event, maskedvalue, floatvalue) => {
        form.change(input.name, floatvalue);
    }
        
    return (
        <>
            <Form.Label className="font-weight-bold">
                {label}
            </Form.Label>
            <Form.Control as={CurrencyInput}            
            value={input.value}
            placeholder={placeholder} 
            readOnly={readOnly}
            onChangeEvent={handleChangeMony}
            decimalSeparator=","
            prefix="R$"
            isValid={meta.touched && !meta.error}
            isInvalid={meta.touched && meta.error}
            />
            <input type="hidden" name={input.name} />
            {logCampos(meta)}
        </>
    );
}

export const camposelect = ({input, label, meta, options, styles}) => {
    
    let selected = [];
    if(options.length){
        selected = options.filter(itens => {
            return itens.selected
        });
    }

    let value_props = null;
    if(input.multiple===true){
        value_props = null;/*selected.length?{value: selected}:{}*/
    }else{
        value_props = selected[0]?{value: `${selected[0].value}`}:{}
    }
    
    return (
        <>
            <Form.Label className="font-weight-bold"
            style={styles?styles[input.name]:{}}
            >{label}</Form.Label>
            <Form.Control 
            {...input} as="select" 
            {...value_props}
            isValid={meta.touched && !meta.error}
            isInvalid={meta.touched && meta.error}
            >
                {options.length?options.map((itens, index) => {
                    if(!itens.value && !itens.texto){
                        return null;
                    }
                   
                    return (
                        <option 
                        key={`${index}`} 
                        value={`${itens.value}`}                        
                        >
                            {itens.texto}
                        </option>
                    )
                    
                }):null}
            </Form.Control>
            {logCampos(meta)}
        </>
    );
}

export const camporadio = ({input, label, placeholder, meta, disabled}) => {    
    return (
        <>
            <Form.Check            
            {...input}
            disabled={disabled}
            placeholder={placeholder}        
            label={label}
            isValid={meta.touched && !meta.error}
            isInvalid={meta.touched && meta.error}
            />            
            {logCampos(meta)}
        </>
    );
}

const handleValues = (form, campo, value) => {
    const status = form.getFieldState(campo);
    if(status && status.name){        
        if(status.value !== value){
            form.change(status.name, value)
        }
    }
}

export const Campocalendario = ({input, label, form, meta}) => {
    
    let strdatainicial = ['2000-01-01'];    
    if(form.getState().initialValues[input.name]){
        strdatainicial = form.getState().initialValues[input.name].split(" ");
        if(strdatainicial[0] === '0000-00-00 00:00:00'){
            strdatainicial[0] = '2000-01-01';
        }

        if(strdatainicial[0] === '0000-00-00'){
            strdatainicial[0] = '2000-01-01';
        }
    }
    
    const [valueInitial, onChangeInitial] = useState(new Date(`${strdatainicial[0]} 23:00:00`));
    const [value, onChange] = useState(new Date(`${strdatainicial[0]} 23:00:00`));

    useEffect(() => {
        
        let strdata = input.value.split(" ");        
        if(strdata[0] === '0000-00-00 00:00:00'){
            strdata[0] = '2000-01-01';
        }

        if(strdata[0] === '0000-00-00'){
            strdata[0] = '2000-01-01';
        }

        if(strdata[0] === ''){
            strdata[0] = '2000-01-01';
            //form.resetFieldState(input.name);
        }
        
        const stateinitial = format(valueInitial,'yyyy-MM-dd');        
        if(stateinitial !== strdatainicial[0]){
            onChangeInitial(new Date(`${strdatainicial[0]} 23:00:00`));
            onChange(new Date(`${strdatainicial[0]} 23:00:00`));
            form.resetFieldState(input.name);
        }

        const data = format(new Date(`${strdata[0]} 23:00:00`),'yyyy-MM-dd');
        const state = format(value,'yyyy-MM-dd');
        if(data !== state){
            form.change(input.name, state);
            const status = form.getFieldState(input.name);
        }

    },[form, input, value, strdatainicial]);
        
    return (
      <>
      <Form.Label className="font-weight-bold">{label}</Form.Label>        
        <input type="hidden" name={input.name} />
        <Calendar    
            locale="pt-br"            
            onChange={onChange}
            value={value}
        />        
        {logCampos(meta)}      
      </>
    );
}

export const OldCampocalendario = ({input, label, form, meta}) => {
    console.log(input.value);
    const [value, onChange] = useState(new Date(input.value));
    const [inicializado, onInicializado] = useState(false);
    useEffect(() => {
        const status = form.getFieldState(input.name);
        if(status && status.name){            
            console.log(status.initial, value, status.dirty, inicializado);
            if((status.initial && status.dirty === false) && inicializado === false){
                let data = status.initial;
                if(data === '0000-00-00 00:00:00'){
                    data = '2000-01-01';
                }                
                const dataincial = format(new Date(data),'yyyy-MM-dd');
                const datastate = format(value,'yyyy-MM-dd');
                if(datastate !== dataincial && dataincial !== undefined){
                    onChange(new Date(data));
                    handleValues(form,input.name,format(value,'yyyy-MM-dd'));                
                    form.resetFieldState(input.name);
                    onInicializado(true);
                }
            }else{                
                handleValues(form,input.name,format(value,'yyyy-MM-dd'));
                onInicializado(false);
            }
        }
    },[form, input.name, inicializado, value]);
    
    return (
      <>
      <Form.Label className="font-weight-bold">{label}</Form.Label>        
        <input type="hidden" name={input.name} value={format(value,'yyyy-MM-dd')}/>
        <Calendar    
            locale="pt-br"            
            onChange={onChange}
            value={value}
        />        
        {logCampos(meta)}      
      </>
    );
}

export const Campoupload = ({input, label, numeroupload, form, meta, info, infoResolution, preimagens, resolutionHeight, resolutionWidth, resolutionType, actionRemoveItem, itensInitialize}) => {

    const [images, setImages] = useState([]);
       
    const onChange = (imageList, addUpdateIndex) => {        
        setImages(imageList);
        if(imageList.length === 0){            
            form.change(input.name,null);
            const itens = itensInitialize.imagens.filter(itens => {
                return itens.campo !== input.name;
            });
            delete itensInitialize.imagens;
            itensInitialize = {
                ...itensInitialize,
                imagens: itens
            }
            actionRemoveItem(JSON.stringify(itensInitialize));
        }        
    };

    const imgjson = images.length?JSON.stringify(images):'';
    useEffect(() => {
        handleValues(form,input.name,imgjson);
        if(meta.submitSucceeded === true && images.length){
            setImages([]);
        }
        if(preimagens.length){
            setImages(preimagens);
        }
    },[form, input.name, imgjson, meta, images.length, preimagens]);

    return (
      <>        
        <ImageUploading            
            multiple
            maxFileSize={250000}
            value={images}
            onChange={onChange}
            maxNumber={numeroupload}
            dataURLKey="data_url"
            resolutionType={resolutionType}
            resolutionHeight={resolutionHeight}
            resolutionWidth={resolutionWidth}
        >
          {({
            imageList,
            onImageUpload,
            onImageRemoveAll,
            onImageUpdate,
            onImageRemove,
            isDragging,
            dragProps,
            errors
          }) => (
            // write your building UI
            <div className="upload__image-wrapper">                
                <input type="hidden" name={input.name} value={imgjson} />
                <Button
                    style={isDragging ? { color: 'red' } : undefined}
                    onClick={onImageUpload}
                    {...dragProps}
                    className="mb-1">
                    {label}
                    <br />
                    <ImageAdd size="35" />
                </Button>                
                {errors&&errors.maxFileSize?<p className="text-sm-left">{info}</p>:null}
                {errors&&errors.resolution && <p className="text-sm-left">{infoResolution}</p>}
              &nbsp;              
              {imageList&&imageList.length>1?
              <Button onClick={onImageRemoveAll}>Remover Todas Imagem</Button>
              :
              null
              }
              {imageList.map((image, index) => (
                <div key={`${input.name}_${index}`} className="image-item">
                    <img src={image['data_url']} alt="" width="100" />
                    <div className="image-item__btn-wrapper">
                        <Button onClick={() => onImageUpdate(`${input.name}_${index}`)} className="mr-1 mt-1"><CommentEdit size="35" /></Button>
                        <Button onClick={() => onImageRemove(`${input.name}_${index}`)} className="mt-1"><DeleteForever size="35" /></Button>
                    </div>
                </div>
              ))}
            </div>
          )}
        </ImageUploading>
        {logCampos(meta)}
      </>
    );
}

export const camposelectsearch = ({input, id, label, meta, readOnly, form, options, placeholder, onChange}) => {    

    const handleChange = (data) => {
        const value = data[0]?data[0].id:'';
        form.change(input.name, value);
        onChange(value);
    }
            
    return (
        <>
            <Form.Label className="font-weight-bold">
                {label}
            </Form.Label>
            <Typeahead
            id={id}            
            options={options&&options.length?options:[]}
            inputProps={{name: input.name}}
            onChange={(value) => {
                handleChange(value);
            }}            
            readOnly={readOnly}            
            placeholder={placeholder}
            isValid={meta.touched && !meta.error}
            isInvalid={meta.touched && meta.error}
            />            
            {logCampos(meta)}
        </>
    );
}

export const campoeditor = ({input, label, meta, readOnly, form}) => {    

    const handleChange = (data) => {
        form.change(input.name, data);
    }
            
    return (
        <>
            <Form.Label className="font-weight-bold">
                {label}
            </Form.Label>
            <Form.Control as={Editor}            
            value={input.value}
            readOnly={readOnly}
            onChangeEvent={handleChange}            
            isValid={meta.touched && !meta.error}
            isInvalid={meta.touched && meta.error}
            name={input.name}
            />            
            {logCampos(meta)}
        </>
    );
}

export const Editor = ({name, onChangeEvent, value}) => {

    const [data, setData] = useState(value);
    useEffect(() => {
        setData(value);
    },[value])

    return (        
        <CKEditor
            name={name}            
            editor={ClassicEditor}
            data={data}
            onReady={(editor) => {
                // You can store the "editor" and use when it is needed.
                editor.plugins.get("FileRepository").createUploadAdapter = (loader) => new MyUploadAdapter(loader);                
            }}
            config={{                
                toolbar: [
                    "selectAll",
                    "undo",
                    "redo",
                    "bold",
                    "italic",
                    "blockQuote",
                    "ckfinder",
                    "imageTextAlternative",
                    "imageUpload",
                    "heading",
                    "imageStyle:full",
                    "imageStyle:side",
                    "indent",
                    "outdent",
                    "link",
                    "numberedList",
                    "bulletedList",
                    "mediaEmbed",
                    "insertTable",
                    "tableColumn",
                    "tableRow",
                    "mergeTableCells",
                    "fontBackgroundColor",
                    "fontColor"
                ],
                image: {
                    // Configure the available styles.
                    styles: ["alignLeft", "alignCenter", "alignRight"],
                    sizes: ["50%", "75%", "100%"],
                    // Configure the available image resize options.
                    resizeOptions: [
                        {
                            name: "imageResize:original",
                            label: "Original",
                            value: null
                        },
                        {
                            name: "imageResize:50",
                            label: "50%",
                            value: "50"
                        },
                        {
                            name: "imageResize:75",
                            label: "75%",
                            value: "75"
                        }
                    ],
                    // You need to configure the image toolbar, too, so it shows the new style
                    // buttons as well as the resize buttons.
                    toolbar: [
                        "imageStyle:alignLeft",
                        "imageStyle:alignCenter",
                        "imageStyle:alignRight",
                        "|",
                        "imageResize",
                        "|",
                        "imageTextAlternative"
                    ]
                }
            }}
            onChange={(event, editor) => {
                const data = editor.getData();
                setData(data);
                onChangeEvent(data);
            }}
            onBlur={(event, editor) => {
                console.log("Blur.", editor);
                console.log(Array.from(editor.ui.componentFactory.names()));                
            }}
            onFocus={(event, editor) => {
                console.log("Focus.", editor);                
            }}
        />        
    );
}
